import { useEffect } from "react";

/**
 * Swap dinâmico do manifest / theme-color / apple-title para o PWA
 * do "CD Cotações". Sem isso, o navegador instalaria o PWA usando
 * o manifest padrão (Compromisso Digital / Loja) e o app apareceria
 * com o nome errado no home screen.
 *
 * Aplicar apenas nas telas do produto Cotações que o cliente pode
 * instalar (Landing, Login, Dashboard). NÃO usar na tela pública do
 * fornecedor (/cotacoes/responder/:token) — aquela é para o
 * fornecedor externo, não para o dono da conta.
 */
export default function useCotacaoPwa() {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    const titleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');

    const prevManifest = link?.getAttribute("href");
    const prevTheme = themeMeta?.getAttribute("content");
    const prevTitle = titleMeta?.getAttribute("content");

    if (link) link.setAttribute("href", "/manifest-cotacoes.json");
    if (themeMeta) themeMeta.setAttribute("content", "#1741D3");
    if (titleMeta) titleMeta.setAttribute("content", "CD Cotações");

    return () => {
      if (link && prevManifest) link.setAttribute("href", prevManifest);
      if (themeMeta && prevTheme) themeMeta.setAttribute("content", prevTheme);
      if (titleMeta && prevTitle) titleMeta.setAttribute("content", prevTitle);
    };
  }, []);
}
